import type { TrendItemContentTweetsItemMediaLinksItemProjectInfoEngagementAllOf } from './trendItemContentTweetsItemMediaLinksItemProjectInfoEngagementAllOf';
import type { TrendItemContentTweetsItemMediaLinksItemProjectInfoEngagementAllOfTwo } from './trendItemContentTweetsItemMediaLinksItemProjectInfoEngagementAllOfTwo';

/**
 * 프로젝트 참여 통계
 */
export type TrendItemContentTweetsItemMediaLinksItemProjectInfoEngagement = TrendItemContentTweetsItemMediaLinksItemProjectInfoEngagementAllOf & TrendItemContentTweetsItemMediaLinksItemProjectInfoEngagementAllOfTwo;
